import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { IndividualMonitoringDetail } from "../types/Individual";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string, individualId: number) => () =>
  axios.get<IndividualMonitoringDetail>(
    `${env.verifyServiceUrl}individual/monitoring/${individualId}/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

export const useMonitoringDetail = (id) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["monitoringDetail", id], fetch(authHeader, id), {retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
